// Nuxt and Nitro reserve the "_" prefix (_nuxt, _ipx, _plausible), "." belongs to well-known URIs.
export const canBeMerchantSlug = (slug: string): boolean =>
	!slug.startsWith('_') && !slug.startsWith('.');
